module.exports = __webpack_public_path__ + "media/images/s_key-b7e68cc4cc38e439bbf797ab8ce920ac.jpeg";